import { workflowSteps } from '@/mocks/siteData';

export default function WorkflowSteps() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Basetao Complete Buying System
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Follow this proven six-step workflow to build an efficient Basetao Spreadsheet shopping system.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {workflowSteps.map((step) => (
            <div key={step.step} className="relative flex gap-4 p-5 bg-background-50 rounded-lg border border-background-200/70">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                <span className="text-sm font-bold text-background-50">{step.step}</span>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}